export interface PerformanceData {
  id: string;
  formal_name: string;
  display_name: string;
  account_id: string;
  account_name: string;
  attribution_window?: string;
  attribution_basis?: string;
  selected_conversion_event?: string;
  selected_conversion_tag_names?: string[]; // Array of strings
  currency_conversion?: string;
  emq_primary_conversion?:string;
  emq_secondary_conversion?:string;
  emq_tertiary_conversion?:string;
  notes?: string; // Optional field
}

export interface PerformanceState {
  performanceData: PerformanceData[];
  addDialogOpen: boolean;
  editDialogOpen: boolean;
  editData: PerformanceData | null;
}

export const SET_PERFORMANCE_DATA = "SET_PERFORMANCE_DATA";
export const ADD_PERFORMANCE_DATA = "ADD_PERFORMANCE_DATA";
export const UPDATE_PERFORMANCE_DATA = "UPDATE_PERFORMANCE_DATA";
export const SET_ADD_DIALOG_OPEN = "SET_ADD_DIALOG_OPEN";
export const SET_EDIT_DIALOG_OPEN = "SET_EDIT_DIALOG_OPEN";
export const SET_EDIT_DATA = "SET_EDIT_DATA";

export interface SetPerformanceDataAction {
  type: typeof SET_PERFORMANCE_DATA;
  payload: PerformanceData[];
}

export interface AddPerformanceDataAction {
  type: typeof ADD_PERFORMANCE_DATA;
  payload: PerformanceData;
}

export interface UpdatePerformanceDataAction {
  type: typeof UPDATE_PERFORMANCE_DATA;
  payload: {
    index: number;
    data: PerformanceData;
  };
}

export interface SetAddDialogOpenAction {
  type: typeof SET_ADD_DIALOG_OPEN;
  payload: boolean;
}

export interface SetEditDialogOpenAction {
  type: typeof SET_EDIT_DIALOG_OPEN;
  payload: boolean;
}

export interface SetEditDataAction {
  type: typeof SET_EDIT_DATA;
  payload: PerformanceData | null;
}

// Combine all action types into a union type
export type PerformanceActionTypes =
  | SetPerformanceDataAction
  | AddPerformanceDataAction
  | UpdatePerformanceDataAction
  | SetAddDialogOpenAction
  | SetEditDialogOpenAction
  | SetEditDataAction;
